import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		tags: []
	},

	actions: {
		fetchAll ({ commit }) {
			return window.axios.get('/tags').then(({ data }) => {
				commit(types.STORE_ALL_TAGS, data)
				return data
			})
		},

		create ({ commit }, { name }) {
			return window.axios.post('/tags', { name }).then((data) => {
				return data
			})
		},

		update ({ commit }, { id, name }) {
			return window.axios.post(`/tags/${id}`, { name }).then((data) => {
				return data
			})
		},

		delete ({ commit }, { id }) {
			return window.axios.delete(`/tags/${id}`).then((data) => {
				return data
			})
		}
	},

	mutations: {
		[types.STORE_ALL_TAGS] (state, tags) {
			state.tags = tags
		}
	},

	getters: {
		getTagById: state => id => state.tags.find(c => c.id === id)
	}
}
